<template>
  <div class="gotop" v-show="gotop" @click="toTop"><i class="el-icon-caret-top"></i></div>
</template>

<script>
export default {
  name: "ScrollTop",
  data() {
    return {
      gotop: false,
    };
  },
  mounted() {
    // 此处true需要加上，不加滚动事件可能绑定不成功
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll() {
      //注意不同浏览器之间的兼容性
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  },
};
</script>

<style>
.gotop {
  text-align: center;
  font-size: 20px;
  position: fixed;
  right: 20px;
  bottom: 10px;
  cursor: pointer;
  padding: 10px;
  border-radius: 50%;
  background:rgba(242, 242, 242, 1);
  color: #133b95;
}
</style>


// WEBPACK FOOTER //
// src/components/common/ScrollTop.vue